export default __webpack_public_path__ + "static/media/ChartofAccounts.84d14b02.svg";